import { Requester, ResponseOptions } from './types';
import { HttpError } from './HttpError';

export const fetchRequster: Requester = async (options) => {
  const result: ResponseOptions = {};

  try {
    const response = await fetch(options.url, options.params);
    result.status = response.status;
    result.result = await response.text();

    if (!response.ok) {
      result.error = new HttpError('response');
    }
  } catch (error) {
    const kind =
      'navigator' in window && window.navigator.onLine ? 'unknown' : 'offline';
    result.error = new HttpError(kind);
  }

  return result;
};
